<div class="line">
    <div class="line__box" [ngStyle]="{borderColor:color}"></div>
    <div class="line__line" [ngStyle]="{backgroundColor:color}"></div>
</div>